import { SubscriptionRequiresAction as Component } from "./SubscriptionRequiresAction";
import { SubscriptionRequiresAction as container } from "./SubscriptionRequiresActionContainer";

// @ts-ignore
const SubscriptionRequiresAction = container(Component);

export { SubscriptionRequiresAction };
